import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { NumericDirective } from './directives/numeric.directive'
import { FontAwesomeModule, FaConfig, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { CommonModule } from '@angular/common';
import { AttachFilesComponent } from './components/attach-files/attach-files.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { SupplierProfileComponent } from './components/supplier-profile/supplier-profile.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';

@NgModule({
    imports: [
        MatCardModule,
        MatSidenavModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        MatPaginatorModule,
        MatToolbarModule,
        MatStepperModule,
        MatInputModule,
        MatSelectModule,
        MatDialogModule,
        MatRadioModule,
        MatAutocompleteModule,
        FontAwesomeModule,
        MatBottomSheetModule,
        CommonModule,
        FormsModule,
        MatListModule,
        MatTooltipModule,
    ],
    declarations: [
        NumericDirective,
        AttachFilesComponent,
        SupplierProfileComponent,
        ConfirmDialogComponent,
    ],
    exports: [
        MatCardModule,
        MatSidenavModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        MatPaginatorModule,
        MatToolbarModule,
        MatStepperModule,
        MatInputModule,
        MatSelectModule,
        MatDialogModule,
        MatRadioModule,
        MatAutocompleteModule,
        FontAwesomeModule,
        NumericDirective,
        MatBottomSheetModule,
        AttachFilesComponent,
        MatListModule,
        MatTooltipModule,
        SupplierProfileComponent,
        ConfirmDialogComponent
    ],
    providers: [FaConfig, FaIconLibrary]
})

export class SharedModule { }
